import React from "react";

import Icon from "../Icon";

/**
 * Cadeia do registro: onde ele está no fluxo. `now` é a primeira etapa não
 * concluída — é ela que responde "onde isso parou" antes de qualquer leitura.
 */
export const Chain = ({ steps = [], labels = {}, title }) => {
    if (!steps.length) return null;

    return (
        <div className="linked-chain">
            {title && <span className="linked-chain-label">{title}</span>}
            <div className="linked-chain-track">
                {steps.map((step, index) => (
                    <React.Fragment key={step.key}>
                        {index > 0 && <span className="linked-chain-line" />}
                        <div className={`linked-chain-step ${step.state}`}>
                            <span className="bullet">
                                {step.state === 'done' && <Icon name="check" size={11} strokeWidth={3} />}
                            </span>
                            <span>{labels[step.key] ?? step.key}</span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}

export default Chain;
